import BenchlingConfig from 'BenchlingConfig';
import {DEFAULT_DATA_FRAME_ROW_LIMIT} from 'data-frames/graphql/GetDataFrame';
import {DATA_FRAME_TABLE_CONSTANTS} from 'data-frames/table/DataFrameTable';
import {DataFrameSortInputVariable} from 'data-frames/util/toDataFrameSortInput';

export interface DataFramePaginationQueryVariables {
  useServerPagination: boolean;
  limit: number;
  offset: number;
  sortInput: DataFrameSortInputVariable | null;
}

/**
 * Server-side pagination/sorting for persisted data frame tables is gated behind
 * `ENABLE_DATA_FRAMES_NO_ROW_LIMIT`; when disabled, callers fall back to the legacy single-fetch,
 * client-side-paginated/sorted behavior (bounded by `DEFAULT_DATA_FRAME_ROW_LIMIT`).
 */
export default function getDataFramePaginationQueryVariables({
  rowsOffset,
  sortInput,
  rowLimit,
}: {
  rowsOffset: number;
  sortInput: DataFrameSortInputVariable | null;
  rowLimit?: number;
}): DataFramePaginationQueryVariables {
  const useServerPagination = rowLimit == null && BenchlingConfig.ENABLE_DATA_FRAMES_NO_ROW_LIMIT;
  return {
    useServerPagination,
    limit:
      rowLimit ??
      (useServerPagination ? DATA_FRAME_TABLE_CONSTANTS.MAX_ROWS_PER_PAGE : DEFAULT_DATA_FRAME_ROW_LIMIT),
    offset: useServerPagination ? rowsOffset : 0,
    sortInput: useServerPagination ? sortInput : null,
  };
}
